import React, { useState } from 'react'
import ReactAnimatedNumber from '@jhonnold/react-animated-number'
import { InView } from 'react-intersection-observer'

const formatter = new Intl.NumberFormat('cs-CZ', { maximumFractionDigits: 0 })

interface AnimatedNumberProps {
	number: number
}

const AnimatedNumber: React.FC<AnimatedNumberProps> = ({ number }) => {
	const [currentNumber, setCurrentNumber] = useState(0)

	return (
		<InView
			onChange={(inView) =>
				inView && currentNumber !== number && setCurrentNumber(number)
			}
		>
			<ReactAnimatedNumber
				number={currentNumber}
				duration={2000}
				format={(value: number): string => formatter.format(value)}
				component="div"
			/>
		</InView>
	)
}

export default AnimatedNumber
